export function getElapsedTimeFormatted(recordingStartTime: number, dateNow: number): string {
  if (!recordingStartTime || dateNow < recordingStartTime) {
    return "00:00";
  }

  const elapsedMs = dateNow - recordingStartTime;
  const totalSeconds = Math.floor(elapsedMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const paddedMinutes = String(minutes).padStart(2, "0");
  const paddedSeconds = String(seconds).padStart(2, "0");

  return `${paddedMinutes}:${paddedSeconds}`;
}
